module.exports = __webpack_public_path__ + "static/img/1_5_2.7b3837fe.jpg";